export const MAX_GALLERY_IMAGES_LENGTH = 8;
